
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("83vnx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $870c2a35ca4d52d2$export$2e2bcd8739ae039);
const $870c2a35ca4d52d2$var$Empty = ()=>null;
var $870c2a35ca4d52d2$export$2e2bcd8739ae039 = $870c2a35ca4d52d2$var$Empty;

});


//# sourceMappingURL=async-legacy-page-entrypoint.145a654f.js.map
